import { Component, Host, h, Element } from '@stencil/core';
import { transformChildElements } from '../../utils/transformers';

@Component({
  tag: 'me-article',
  styleUrl: 'me-article.scss',
  shadow: false,
})
export class MeArticle {

  @Element() host: HTMLElement;

  componentWillLoad() {
    transformChildElements(this.host);
  }

  render() {
    return (
      <Host class="me-article">
        <div class="me-article__teaser">
          <slot name="teaser"></slot>
        </div>
        <div class="me-article__text">
          <slot name="text"></slot>
        </div>
      </Host>
    );
  }

}
